import API from "serviceshift-ui/api-client";
import { computeClockSkewMs } from "@/lib/clockSkew";

export default {
  async fetchClockedInStatus({ dispatch }) {
    try {
      const res = await API.makeRequest("/admin/v4/time_cards/status", {
        method: "GET"
      });
      if (res.data) {
        const clockSkewMs = computeClockSkewMs(res.data.server_time);
        dispatch("updateCurrentAdmin", {
          clockedIn: res.data.is_clocked_in,
          clockedInAt: res.data.created_at,
          clockSkewMs
        });
        if (Math.abs(clockSkewMs) > 5 * 60 * 1000) {
          window.Sentry?.captureMessage(
            "Admin browser clock is skewed from server clock",
            {
              level: "warning",
              extra: { clockSkewMs, serverTime: res.data.server_time }
            }
          );
        }
      }
    } catch (e) {
      console.error(e);
    }
  },
  async clockIn({ dispatch }) {
    try {
      const res = await API.makeRequest("/admin/v4/time_cards/clock_in", {
        method: "POST"
      });
      if (res.data) {
        dispatch("updateCurrentAdmin", { clockedIn: res.data.is_open });
      }
    } catch (e) {
      console.error(e);
    }
  },
  async clockOut({ dispatch }) {
    try {
      const res = await API.makeRequest("/admin/v4/time_cards/clock_out", {
        method: "PUT"
      });
      if (res.data) {
        dispatch("updateCurrentAdmin", { clockedIn: res.data.is_open });
      }
    } catch (e) {
      console.error(e);
    }
  },
  updateCurrentAdmin({ commit }, data) {
    commit("update", {
      state: "currentAdmin",
      data
    });
  },
  setCurrentAdmin({ commit }, data) {
    commit("replace", {
      state: "currentAdmin",
      data
    });
  }
};
